// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading_RuE_p_8{font-weight:600;font-size:24px;margin-bottom:1rem}`, "",{"version":3,"sources":["webpack://./components/ui/heading/heading.module.scss"],"names":[],"mappings":"AAAA,iBACC,eAAA,CACA,cAAA,CACA,kBAAA","sourcesContent":[".heading {\n\tfont-weight: 600;\n\tfont-size: 24px;\n\tmargin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export var heading = `heading_RuE_p_8`;
export default ___CSS_LOADER_EXPORT___;
